var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.structuralElement
    ? _c("sidebar-widget", {
        attrs: {
          title: _vm.$gettext("Ansichten"),
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _c(
                    "ul",
                    {
                      staticClass:
                        "widget-list widget-links sidebar-views cw-view-widget",
                    },
                    [
                      _c(
                        "li",
                        {
                          class: {
                            active: _vm.readView,
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              on: {
                                click: _vm.setReadView,
                              },
                            },
                            [_c("translate", [_vm._v("Lesen")])],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.canEdit
                        ? _c(
                            "li",
                            {
                              class: {
                                active: _vm.editView,
                              },
                            },
                            [
                              _c(
                                "button",
                                {
                                  on: {
                                    click: _vm.setEditView,
                                  },
                                },
                                [_c("translate", [_vm._v("Bearbeiten")])],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.context.type === "courses" && _vm.canVisit
                        ? _c(
                            "li",
                            {
                              class: {
                                active: _vm.discussView,
                              },
                            },
                            [
                              _c(
                                "button",
                                {
                                  on: {
                                    click: _vm.setDiscussView,
                                  },
                                },
                                [_c("translate", [_vm._v("Kommentieren")])],
                                1
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          1079194460
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }